<template>
      <!-- 筛选条件tab -->
    <ul v-if="filtes.length > 0" class="filter_tab">
      <li class="decorate left"></li>
      <li class="decorate right"></li>
      <li
        v-for="(item, index) in filtes"
        :key="item.type"
        @click="()=> select({index, type: item.type})"
        :class="['filter_item', type === item.type ? 'active' : '',type === undefined?'active':'']"
        :style="{backgroundImage: `url(${ type === item.type ||(filtes[0].type === undefined && activeIndex == 0) ? item.selectIcon : item.defaultIcon})`}"
      > {{item.name}}</li>
    </ul>
</template>

<script>
import {icons} from '../config/constant';

export default {
    props: {
        filtes: {
            type: Array
        }
    },
    data() {
        return {
            icons,
            index: 0,
            type: "",
            activeIndex:0
        }
    },
    methods: {
        select({index, type}) {
            this.index = index;
            this.activeIndex = index
            this.type = type;
            this.$emit("select", {index, type})
        }
    }
}
</script>

<style lang="scss" scoped>

.filter_tab {
  display:flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  left: 50%;
  bottom: 63px;
  transform: translate(-50%, 0);
  height: 36px;
  background-color:rgba(15, 36, 69, 0.8);
  border: solid 1px #2bc2ff;
  box-sizing: border-box;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  clip-path: polygon(10px 0, 100% 0, 100% 26px, calc(100% - 10px) 36px, 0 36px, 0 10px);

  .decorate{
    position: absolute;
    border-bottom: 1px solid #2bc2ff;
    width: 16px;
    transform: rotate(-45deg);
  }
  .left {
    left: -3px;
    top: 3px;
  }
  .right {
    right: -3px;
    bottom: 3px;
  }
  .filter_item {
    margin: 0 20px;
    padding-left: 24px;
    font-size: 14px;
    color: #6f8797;
    background-repeat: no-repeat;
    background-size: auto 14px;
    background-position: left center;
  }
  .filter_item.active {
      color: #00a8ff;
  }
}

</style>